import { WishlistItemType, WishlistType } from "lib/types/wishlist";

export const parseWishlistData = (wishlistResponse: any): WishlistType => {
  if (!wishlistResponse || !Boolean(wishlistResponse)) {
    return {
      count: 0,
      wishlistedItems: [],
    };
  }

  const wishlists = wishlistResponse?.wishlists;

  const wishlistItems: WishlistItemType[] =
    Boolean(wishlists) && Boolean(wishlists?.length)
      ? wishlists.flatMap((entry: any): WishlistItemType[] => {
          const productData = entry?.product_data;
          const productId = productData?.product_id ?? entry?.product_id ?? "";
          const productName = productData?.name ?? "";
          const productDescription = productData?.description ?? "";
          const productImages = productData?.images ?? [];
          const productVariants = productData?.variants ?? [];
          const defaultImage = productImages?.find((image: any) => image?.is_primary)?.src;

          const variantIds: string[] = Boolean(entry?.variant_ids?.length)
            ? entry?.variant_ids
            : productVariants.map((variant: any) => variant?.variant_id);

          return variantIds.map((variantId: string): WishlistItemType => {
            const variant = productVariants.find((item: any) => item?.variant_id === variantId);
            const variantImage: string =
              productImages?.find((image: any) => image?.linked_variant_ids?.includes(variantId))?.src ??
              defaultImage;
            return {
              variantId: variantId,
              variantName:
                Boolean(variant?.name) && variant?.name !== "Default Title" ? variant?.name : "",
              sku: variant?.sku ?? "",
              link: Boolean(productDescription)
                ? "/products/" + productDescription + "?variant=" + variantId
                : "",
              image: variantImage,
              productId: productId,
              productName: productName,
              originalPrice: variant?.original_price ?? 0,
              currentPrice: variant?.current_price ?? 0,
            };
          });
        })
      : [];

  return {
    count: wishlistResponse?.total_count ?? wishlistItems.length,
    wishlistedItems: wishlistItems,
  };
};
